import type { IconType } from '@/lib/types'

export interface NavItem {
    pathname: string
    iconName: IconType
    iconColor: string
    iconBackgroundColor: string
    title: string
    description: string
    testID: string
}

type Role = 'admin' | 'clerical' | 'workforce' | null

export function getNavItems(role: Role): NavItem[] {
    const isNotWorkforce = role !== 'workforce' && role !== null

    return [
        {
            pathname: '/[orgSlug]/entry',
            iconName: 'clock-outline',
            iconColor: '#f57c00',
            iconBackgroundColor: '#fff3e0',
            title: 'Time Entry',
            description: 'Record time entries and track work hours',
            testID: 'quick-action-entry',
        },
        {
            pathname: '/[orgSlug]/monitor',
            iconName: 'map-marker-path',
            iconColor: '#7b1fa2',
            iconBackgroundColor: '#f3e5f5',
            title: 'Monitor',
            description: 'Track real-time location and movement of team members',
            testID: 'quick-action-monitor',
        },
        {
            pathname: '/[orgSlug]/approval',
            iconName: 'clipboard-check-outline',
            iconColor: '#0288d1',
            iconBackgroundColor: '#e1f5fe',
            title: 'Approval',
            description: 'Review and approve time entries, view reports and analytics',
            testID: 'quick-action-approval',
        },

        {
            pathname: '/[orgSlug]/analytics',
            iconName: 'chart-bar' as IconType,
            iconColor: '#1565c0',
            iconBackgroundColor: '#e3f2fd',
            title: 'Analytics',
            description: 'View team performance metrics and trends',
            testID: 'quick-action-analytics',
        },
        {
            pathname: '/[orgSlug]/settings',
            iconName: 'cog',
            iconColor: '#616161',
            iconBackgroundColor: '#f5f5f5',
            title: 'Settings',
            description: isNotWorkforce
                ? 'Configure organization, team, jobs, and customers'
                : 'Update your profile and password',
            testID: 'quick-action-settings',
        },
    ]
}
